import { IPartnerRecord } from 'clickNgo/entities/partner/models'

import { PARTNER_HISTORY_KEY } from '../configs'

export const setLocalUserHistory = async (items: IPartnerRecord[]) => {
  if (localStorage) {
    localStorage.setItem(PARTNER_HISTORY_KEY, JSON.stringify(items))
  }
}
